import CentralExternalReferral from "./ExternalReferral/CreateExternalReferral.vue";
import CentralInquiry from "./Inquiry/CentralInquiry.vue";
import CentralReferral from "./Referral/CentralReferral.vue";

const routes = [
    {
        path: "/axxess-central/intake/inquiry-list",
        component: CentralInquiry,
        name: "inquiry-list",
        meta: {
            menuName: "Inquiries",
            navItem: "tabInquiry",
            showAxxessCentral: true
        }
    },
    {
        path: "/axxess-central/intake/referral-list",
        component: CentralReferral,
        name: "referral-list",
        meta: {
            menuName: "Referrals",
            navItem: "tabReferral",
            showAxxessCentral: true
        }
    },
    {
        path: "/axxess-central/intake/external-referral-list",
        component: CentralExternalReferral,
        name: "external-referral-list",
        meta: {
            menuName: "External Referrals",
            navItem: "tabExternalReferral",
            showExternalReferral: true,
            showAxxessCentral: true
        }
    }
];
export default routes;
